"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SideNavigation_1 = __importDefault(require("./SideNavigation"));
exports.default = SideNavigation_1.default;
